import { ApiBaseService, ApiV2Service } from './api.base.service';
import store from '@/store/store';
import { Application, SuccessResponse } from '../types';

export interface SearchApplicationsResponse {
  applications: Application[];
  columnFilters: any;
  total: number;
}

export class ApplicationService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async getApplications(): Promise<Application> {
    const organisation = store.getters.activeOrganisationId;
    return this.api.get(`reporting/${organisation}/applications`);
  }

  public async getAdminApplications(): Promise<SearchApplicationsResponse> {
    const organisation = store.getters.activeOrganisationId;
    return this.api.get(`applications`);
  }

  public async createApplication(details: object): Promise<Application> {
    const organisation = store.getters.activeOrganisationId;
    return this.api.post(`organisation/${organisation}/application`, details);
  }

  public async updateApplication(id: number, payload: object): Promise<Application> {
    const organisation = store.getters.activeOrganisationId;
    return this.api.put(`organisation/${organisation}/application/${id}`, payload);
  }

  public async deleteApplication(id: number): Promise<SuccessResponse> {
    const organisation = store.getters.activeOrganisationId;
    return this.api.delete(`organisation/${organisation}/application/${id}`);
  }

  public async getAdminDashboards(): Promise<any> {
    return this.api.get(`applications/dashboards`);
  }

  public async getApplicationSessionId(applicationId: string): Promise<{ sessionId: string }> {
    return this.api.get(`application/${applicationId}/sessionid`);
  }
}

export default new ApplicationService();
